import styled from '@emotion/styled'
import { Theme, Tooltip, Button } from '@yuno/design-system-web'
import ConnectionItem from '../connection-item'
import { useVerifyPermission } from '@yuno/dashboard-container-mfe'
import { PermissionsAvailable } from '@yuno/dashboard-authentication-mfe'
import { useTranslation } from 'react-i18next'

type StyledProps = { theme?: Theme }

interface ConnectionCardProps {
  onClick: () => void
  connection: any
}

const Wrapper = styled('div')(
  ({ theme, disabled }: { theme?: Theme; disabled?: boolean }) => ({
    padding: '16px',
    boxSizing: 'border-box',
    background: `${theme.palette.neutral.white[0]}`,
    border: `1px solid ${theme.palette.grey[2]}`,
    borderRadius: '4px',
    margin: '0 20px 20px 0',
    '&:hover': {
      border: `1px solid ${theme.palette.vivid.brand}`,
      boxShadow: `0px 10px 10px ${theme.palette.neutral.shadow}`,
      borderRadius: '4px',
      '& .MuiButton-root': {
        backgroundColor: !disabled && `${theme.palette.vivid.brand} !important`,
        color: !disabled && `${theme.palette.neutral.white[1]} !important`,
      },
    },
    '& .MuiButton-root': {
      backgroundColor: `${theme.palette.grey[1]} !important`,
      color: `${theme.palette.grey[3]} !important`,
    },
  }),
)

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 34px;
`

export const Category = styled.div<StyledProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.palette.grey[5]};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  font-family: ${({ theme }) => theme.typography.tiny.regular.fontFamily};
  padding-bottom: 5px;
  padding-top: 5px;
  padding-left: 6px;
  padding-right: 6px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
`

const ConnectButton = styled(Button)<StyledProps>`
  text-transform: none !important;
  padding: 8px 24px !important;
  font-size: ${({ theme }) =>
    theme.typography.base.regular.fontSize} !important;
`

export const ConnectionCard = ({
  onClick,
  connection,
}: ConnectionCardProps) => {
  const { allowed } = useVerifyPermission(
    PermissionsAvailable.MANAGE_CONNECTIONS,
  )
  const { t } = useTranslation()

  return (
    <Wrapper disabled={!allowed}>
      <ConnectionItem fullWidth connection={connection} right={t('moreInfo')} />
      <Actions>
        <Category>{connection?.category || t('category')}</Category>
        <Tooltip
          disableHoverListener={allowed}
          title={t('noAccess')}
          color="default"
          arrow
        >
          <span>
            <ConnectButton
              nonce={'undefined'}
              size="small"
              onClick={onClick}
              disabled={!allowed}
            >
              {t('connectOne')}
            </ConnectButton>
          </span>
        </Tooltip>
      </Actions>
    </Wrapper>
  )
}
